import chalk from "chalk"

export const colors = {
  cyan: chalk.cyan,
  magenta: chalk.magenta,
  gray: chalk.gray,
  white: chalk.white,
  yellow: chalk.yellow,
  green: chalk.green,
  red: chalk.red,
  blue: chalk.blue,
  reset: chalk.reset,
  dim: chalk.dim,
  bold: chalk.bold,
  whiteBold: chalk.white.bold,
}
